import { render, staticRenderFns } from "./OurAdvantages.vue?vue&type=template&id=a205e186&scoped=true"
import script from "./OurAdvantages.vue?vue&type=script&lang=js"
export * from "./OurAdvantages.vue?vue&type=script&lang=js"
import style0 from "./OurAdvantages.vue?vue&type=style&index=0&id=a205e186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a205e186",
  null
  
)

export default component.exports